module.exports = __webpack_public_path__ + "img/square-circle.eda7e9a4.png";